import {EnvironmentConfig} from "@me8eon/config";
import {isLocalHost} from "../util/common-util";

const pathResolver = (API: string, isGingco: boolean, params: string) => {
    let urlInitial;
    if (isLocalHost()) {
        urlInitial = isGingco ? EnvironmentConfig.gingcoURL : EnvironmentConfig.gatewayURL;
    } else {
        urlInitial = "";
    }
    const url = `${urlInitial}/${API}${params ?? ""}`;
    return url;
};
export default pathResolver;
